var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"green next-button",attrs:{"tile":"","disabled":_vm.disabled},on:{"click":_vm.click}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }